import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core'
import { ILocation } from 'src/app/core/interfaces/location'
import { LocationsService } from 'src/app/core/services/api/locations.service'
import { LoadingService } from 'src/app/core/services/util/loading.service'
import { AddLocationComponent } from '../../components/dialogs/add-location/add-location.component'
import {
    ConfirmationComponent,
    ConfirmationData,
} from '../../components/dialogs/confirmation/confirmation.component'
import { MatTableDataSource } from '@angular/material/table'
import { MatDialog } from '@angular/material/dialog'
import { MatPaginator } from '@angular/material/paginator'
import { DatePipe } from '@angular/common'
import { TableUtil } from '../../components/util/table-util'

@Component({
    selector: 'app-locations',
    templateUrl: './locations.component.html',
    styleUrls: ['./locations.component.scss'],
})
export class LocationsComponent implements OnInit, AfterViewInit {
    displayedColumns = ['name', 'shortName', 'address', 'actions']
    dataSource = new MatTableDataSource()
    private _locations: ILocation[] = []
    private _filter: string = ''
    get filter() {
        return this._filter
    }
    set filter(filter: string) {
        this._filter = filter
    }

    constructor(
        private locationsService: LocationsService,
        private loadingService: LoadingService,
        public dialog: MatDialog,
        private datePipe: DatePipe
    ) {}

    @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator
    ngOnInit(): void {
        this.loadData()
    }
    ngAfterViewInit(): void {
        this.dataSource.paginator = this.paginator
    }
    loadData() {
        this.locationsService.get().subscribe((result) => {
            console.log('data', result)
            this._locations = result
            this.dataSource.data = result
        })
    }

    addNew() {
        const dialogRef = this.dialog.open(AddLocationComponent, {
            data: {},
            width: '400px',
        })

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                console.log(result)
                this.loadingService.show()
                this.locationsService.post(result).subscribe((response) => {
                    console.log(response)
                    this.loadingService.hide()
                    this._locations.push(response)
                    this.dataSource.data = this._locations
                })
            }
        })
    }
    startEdit(index: number, id: number) {
        var i = this.paginator.pageIndex * this.paginator.pageSize + index
        const dialogRef = this.dialog.open(AddLocationComponent, {
            data: this._locations[i],
            width: '400px',
        })

        dialogRef.afterClosed().subscribe((result) => {
            console.log(result)
            if (result) {
                this.loadingService.show()
                this.locationsService.put(id, result).subscribe((response) => {
                    this.loadingService.hide()
                    this._locations[index] = result
                    this.dataSource.data = this._locations
                })
            }
        })
    }
    deleteItem(id: number, index: number) {
        const data = new ConfirmationData()
        data.description = 'Estas seguro que deseas eliminar la sucursal?'

        const dialogRef = this.dialog.open(ConfirmationComponent, {
            data: data,
        })

        dialogRef.afterClosed().subscribe((result) => {
            console.log(result)
            if (result) {
                this.loadingService.show()
                console.log(id)
                this.locationsService.delete(id).subscribe((response) => {
                    this.loadingService.hide()
                    this._locations.splice(index, 1)
                    this.dataSource.data = this._locations
                })
            }
        })
    }

    exportTable() {
        let data = this.dataSource.filteredData as ILocation[]
        const parsedData: Partial<any>[] = data.map((x) => ({
            Nombre: x.name,
            Abreviatura: x.shortName,
        }))
        let currentDate = this.datePipe.transform(
            new Date(),
            'dd.MM.yyyy-hh.mm'
        )
        TableUtil.exportArrayToExcel(parsedData, 'Ubicaciones' + currentDate)
    }
}
